import * as React from "react";
import { BaseModal } from "../../../atoms/base-modal";

interface ModalWithInputProps {
  isActive: boolean;
  fromServiceProvider: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

export const ConfirmArchiveModal: React.FunctionComponent<
  ModalWithInputProps
> = ({ isActive, fromServiceProvider, onCancel, onSubmit }) => {
  return (
    <BaseModal
      isActive={isActive}
      title="申請をアーカイブする"
      onClose={onCancel}
      style={{ width: "auto" }}
    >
      <section className="modal-card-body">
        <div>
          以下の手続きのみ、アーカイブできます。
          <ul style={{ listStyle: "inside" }} className="ml-4 my-2">
            <li>ステータスが「公開終了」であること。</li>
            <li>
              手続きに紐づく全ての申請のステータスが、「完了」「差し戻し」「取り下げ」のいずれかであること。
            </li>
          </ul>
          {fromServiceProvider ? (
            <>
              手続きをアーカイブすると、テナントユーザーが操作・閲覧できるものは以下のように変わります。
              <ul style={{ listStyle: "inside" }} className="ml-4 my-2">
                <li>
                  アーカイブした手続きには、編集、コピー、エクスポートなどはできず、「アーカイブからの復元」のみ実行できます。
                </li>
                <li>
                  アーカイブした手続きは、手続き一覧から閲覧できなくなります。
                </li>
                <li>
                  アーカイブした手続きに関する申請、申請者レビューは非表示になります。
                </li>
              </ul>
              サービスプロバイダーからは、手続きのエクスポートは可能です。
              <br />
              アーカイブした手続きを復元すると、上記の状態から戻ります。
            </>
          ) : (
            <>
              手続きをアーカイブすると以下のようになります。
              <ul style={{ listStyle: "inside" }} className="ml-4 my-2">
                <li>
                  アーカイブした手続きには、編集、コピー、エクスポートなどはできず、「アーカイブからの復元」のみ実行できます。
                </li>
                <li>
                  アーカイブした手続きは、手続き一覧から閲覧できなくなります。
                </li>
                <li>
                  アーカイブした手続きに関する申請、申請者レビューは非表示になります。
                </li>
              </ul>
              アーカイブした手続きを復元すると、上記の状態から戻ります。
            </>
          )}
        </div>
      </section>
      <footer className="modal-card-foot">
        <button className="button is-failure is-fullwidth" onClick={onCancel}>
          キャンセル
        </button>
        <button
          className="button is-danger is-outlined is-fullwidth"
          onClick={onSubmit}
        >
          アーカイブする
        </button>
      </footer>
    </BaseModal>
  );
};
